/**
 * Composable for managing clustersie theme subdomain detection and configuration
 */
export const useClustersie = () => {
  // Get current subdomain from URL
  const getCurrentSubdomain = () => {
    if (process.client) {
      const hostname = window.location.hostname
      const parts = hostname.split('.')
      
      // Check if we're on localhost or development
      if (hostname === 'localhost' || hostname.includes('127.0.0.1')) {
        // Check for subdomain pattern in development
        const pathname = window.location.pathname
        const subdomainMatch = pathname.match(/^\/([^\/]+)/)
        if (subdomainMatch && ['main', 'coffee', 'fisheries', 'fruit', 'bittermelon', 'halal', 'mulberry'].includes(subdomainMatch[1])) {
          return subdomainMatch[1]
        }
        return 'main'
      }
      
      // Production subdomain detection
      if (parts.length > 2) {
        return parts[0]
      }
    }
    
    // Fallback to main
    return 'main'
  }

  // Get subdomain from query parameter (for testing)
  const getSubdomainFromQuery = () => {
    if (process.client) {
      const urlParams = new URLSearchParams(window.location.search)
      const subdomain = urlParams.get('subdomain')
      if (subdomain && ['main', 'coffee', 'fisheries', 'fruit', 'bittermelon', 'halal', 'mulberry'].includes(subdomain)) {
        return subdomain
      }
    }
    return null
  }

  // Detect if current configuration should use clustersie theme
  const shouldUseClustersieTheme = (configs) => {
    return configs?.theme?.type === 'clustersie'
  }

  // Get available subdomains
  const getAvailableSubdomains = () => {
    return [
      { key: 'main', name: 'หลัก', description: 'แพลตฟอร์มหลัก' },
      { key: 'coffee', name: 'กาแฟ', description: 'คลัสเตอร์กาแฟไทย' },
      { key: 'fisheries', name: 'ประมง', description: 'คลัสเตอร์ประมง' },
      { key: 'fruit', name: 'ผลไม้', description: 'คลัสเตอร์ผลไม้' },
      { key: 'bittermelon', name: 'มะระ', description: 'คลัสเตอร์มะระ' },
      { key: 'halal', name: 'ฮาลาล', description: 'คลัสเตอร์ฮาลาล' },
      { key: 'mulberry', name: 'หม่อน', description: 'คลัสเตอร์หม่อน' }
    ]
  }

  // Navigate to subdomain
  const navigateToSubdomain = (subdomain) => {
    if (!process.client) return

    const current = getCurrentSubdomain()
    if (current === subdomain) return

    const hostname = window.location.hostname
    
    // Handle localhost/development
    if (hostname === 'localhost' || hostname.includes('127.0.0.1')) {
      // For development, use query parameter
      const url = new URL(window.location)
      if (subdomain === 'main') {
        url.searchParams.delete('subdomain')
      } else {
        url.searchParams.set('subdomain', subdomain)
      }
      window.location.href = url.toString()
      return
    }

    // Handle production domains
    const parts = hostname.split('.')
    let newHostname
    
    if (subdomain === 'main') {
      // Remove subdomain for main
      newHostname = parts.slice(-2).join('.')
    } else {
      // Add or replace subdomain
      if (parts.length > 2) {
        newHostname = `${subdomain}.${parts.slice(-2).join('.')}`
      } else {
        newHostname = `${subdomain}.${hostname}`
      }
    }

    const newUrl = `${window.location.protocol}//${newHostname}${window.location.pathname}${window.location.search}`
    window.location.href = newUrl
  }

  return {
    getCurrentSubdomain,
    getSubdomainFromQuery,
    shouldUseClustersieTheme,
    getAvailableSubdomains,
    navigateToSubdomain
  }
}